<template>
    <div>
        <div ref="address"></div>
        <div class="address" :class="{err: err || gpsErr, gray: grayStyle}">
            <img v-if="grayStyle" src="@/assets/img/location-gray.svg">
            <img v-else src="@/assets/img/location.svg">
            <input type="text" v-model="address" @input="search" @focus="onFocus" ref="input" :placeholder="placeholder" :disabled="!enable">
            <img src="@/assets/img/gps-location.svg" @click="getLocation">
            <div class="errMsg" v-show="err || gpsErr">{{ gpsErr || err }}</div>
        </div>
        <div class="tip" v-show="!searching && roadLostNumber">您的地址是否缺少門牌號碼</div>
        <div class="places" v-show="searching">
            <div class="item" v-for="place in results" :key="place.placeId" @click="selectedPlace(place)">
                <img v-show="place.type === 'history'" src="@/assets/img/time.png" class="noOpacity">
                <img v-show="place.type !== 'history'" src="@/assets/img/location.png">
                {{ place.title }}
            </div>
            <div class="zero" v-if="showZero">
                <div class="title">
                    未搜尋到您想要的地址
                </div>
                <div class="content">
                    請檢查搜尋文本並更改
                </div>
                <div class="example">
                    <div class="row">
                        不要包含 <span>樓層</span>
                    </div>
                    <div class="row">
                        <span>4段</span> 改為 <span>四段</span>
                    </div>
                    <div class="row">
                        <span>五巷</span> 改為 <span>5巷</span>
                    </div>
                    <div class="row">
                        <span>二十五號</span> 改為 <span>25號</span>
                    </div>
                    <div class="row">
                        <span>三十弄</span> 改為 <span>30弄</span>
                    </div>
                </div>
            </div>
            <div class="area" v-if="['臺北市', '台北市', '新北市', '桃園市'].includes(area)">
                <div class="content">
                    抱歉，目前{{ area }}只在這些地區服務
                </div>
                <div class="example">
                    <img v-show="area === '桃園市'" src="@/assets/img/taoyuan-map.png">
                    <img v-show="area !== '桃園市'" src="@/assets/img/map.png">
                </div>
                <div class="buttons">
                    <a href="https://paopaotui.com.tw" target="_blank" class="button">
                        查看服務範圍
                    </a>
                </div>
            </div>
            <div class="area" v-else-if="area">
                <div class="content">
                    抱歉，<br/>
                    目前您所在的{{ area }}地區沒有服務
                </div>
                <div class="buttons">
                    <a href="https://paopaotui.com.tw" target="_blank" class="button">
                        查看服務範圍
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { loaded } from 'vue2-google-maps'
    import * as R from 'ramda'
    import * as api from '../../../apis'
    import { mapGetters } from 'vuex'

    export default {
        name: 'SearchAddress',
        props: {
            isFocus: {
                default: false,
            },
            value: {
                default: '',
            },
            placeholder: {
                default: '請輸入要搜尋的 (地址、店名)',
            },
            err: {
                default: '',
            },
            grayStyle: {
                default: false,
            },
            enable: {
                default: true,
            }
        },
        data() {
            return {
                sessionToken: '',
                autocompleteService: '',
                placesService: null,
                geocoder: null,
                places: [],
                histories: [],
                searching: false,
                address: '',
                state: 'history',
                showZero: false,
                area: false,
                searchHistoriesTime: null,
                gpsErr: '',
            };
        },
        computed: {
            results() {
                let results = R.concat(this.histories, this.places);

                return R.isEmpty(results) ? [] : results;
            },
            roadLostNumber() {
                return ! this.address.includes('號') && this.address;
            },
            ...mapGetters(['isLogin', 'canOrderArea'])
        },
        methods: {
            onFocus() {
                this.searching = true;
                this.$emit('onFocus', true);
                this.$refs.input.focus();
                this.$refs.input.dispatchEvent(new Event('input'));
            },
            onBlur() {
                this.searching = false;
                this.gpsErr = '';
                this.$emit('onBlur', true);
            },
            selectedPlace({type, location, title}) {
                if (type === 'history') {
                    this.address = location.city + location.district + location.road;
                    this.$emit('onSelected', {
                        city: location.city,
                        district: location.district,
                        road: location.road,
                        alias: location.alias,
                        latitude: location.latitude,
                        longitude: location.longitude,
                        name: location.name,
                        phone: location.phone,
                        additional: location.additional,
                    });

                    this.onBlur();
                    return ;
                }

                this.geocoder.geocode({
                    address: title
                }, (results, status) => {
                    if (status !== 'OK') return;
                    let result = results[0];
                    let address = this.parseAddressComponents(result.address_components);
                    let city = address.city;
                    let district = address.district;
                    let road = address.road + address.number;
                    let additional = address.additional;

                    district = district.replace('Lake district', '內湖區');

                    if ( ! this.inWhitelist(city, district)) {
                        this.area = city;
                        this.places = [];

                        return;
                    }

                    this.address = city + district + road;
                    this.$emit('onSelected', {
                        city: city,
                        district: district,
                        road: road,
                        additional: additional,
                        latitude: result.geometry.location.lat(),
                        longitude: result.geometry.location.lng(),
                    });
                    this.onBlur();
                });
            },
            parseAddressComponents(components) {
                let city = components.find(data => {
                    return data.types.indexOf('administrative_area_level_1') >= 0;
                });
                if (!city) {
                    city = components.find(data => {
                       return data.types.indexOf('administrative_area_level_2') >= 0;
                    });
                }
                let district = components.find(data => {
                    return data.types.indexOf('administrative_area_level_3') >= 0;
                });
                if(!district || !district.long_name.endsWith('區')) {
                    district = components.find(data => {
                        return data.types.indexOf('administrative_area_level_2') >= 0;
                    })
                }

                let road = components.find(data => {
                    return data.types.indexOf('route') >= 0;
                });
                let number = components.find(data => {
                    return data.types.indexOf('street_number') >= 0;
                });
                if (number && ! number.long_name.includes('號')) {
                    number.long_name = number.long_name + '號';
                }

                let additional = components.find(data => {
                    return data.types.indexOf('subpremise') >= 0;
                });

                return {
                    city: city ? city.long_name : '',
                    district: district ? district.long_name : '',
                    road: road ? road.long_name : '',
                    number: number ? number.long_name : '',
                    additional: additional? additional.long_name : '',
                }
            },
            inWhitelist(city, district) {
                // let validateCity = ['臺北市', '台北市', '新北市', '桃園市'];
                // let validateDistrict = ['松山區', '信義區', '大安區', '中正區', '萬華區', '大同區', '中山區', '士林區', '南港區', '文山區', '三重區', '中和區', '永和區', '板橋區', '新店區', '內湖區', '松山鎮', '桃園區', '八德區', '新莊區', '林口區', '土城區', '蘆洲區', '北投區', '汐止區', '樹林區', '五股區', '泰山區', '龜山區', '中壢區', '平鎮區', '楊梅區'];
                //
                // district = district.replace('区', '區');
                //
                // return R.indexOf(city)(validateCity) >= 0 && R.indexOf(district)(validateDistrict) >= 0;

                // 等待開放全區
                city = city.replace('臺', '台');
                city = city.replace('市', '');
                city = city.replace('縣', '');
                district = district.replace('区', '區');

                if (city === '屏東' && district === '琉球鄉') return false;
                if (city === '台東' && district === '蘭嶼鄉') return false;
                if (city === '台東' && district === '綠島鄉') return false;

                return R.indexOf(city)(this.canOrderArea) >= 0;
            },
            search(e) {
                let value = e.target.value;

                if ( ! this.sessionToken) {

                    return;
                }

                if ( ! value) {
                    return ;
                }

                this.searchHistory(value);

                this.autocompleteService.getPlacePredictions({
                    input: value,
                    sessionToken: this.sessionToken,
                    componentRestrictions: {country: 'tw'}
                }, (predictions, status) => {
                    if (status === 'ZERO_RESULTS') {
                        this.places = [];
                        this.state = 'zero';
                        setTimeout(() => {
                            if (this.state === 'zero') {
                                this.showZero = true;
                            }
                        }, 1000);
                    }

                    if (status !== 'OK') return;

                    this.state = 'result';
                    this.showZero = false;
                    this.area = false;
                    this.places = predictions.map(prediction => {
                        return {
                            title: prediction.description,
                            placeId: prediction.place_id,
                        };
                    });
                });
            },
            searchHistory(value) {
                if (! this.isLogin) {
                    return;
                }

                if (this.searchHistoriesTime) {
                    clearTimeout(this.searchHistoriesTime);
                }

                this.searchHistoriesTime = setTimeout(() => {
                    api.histories(value).then(({ data }) => {
                        this.histories = R.map(location => {
                            let address = location.city + location.district + location.road;
                            let alias = location.alias ? `${location.alias} - ` : '';

                            return {
                                type: 'history',
                                title: alias + address,
                                location,
                            };
                        })(data);
                    }).catch(() => {});
                }, 500);
            },
            getLocation() {
                if (!this.enable) {
                    return;
                }
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.parseGPS(position.coords.latitude, position.coords.longitude);
                    }, err => {
                        switch (err.code) {
                            case err.PERMISSION_DENIED:
                                this.gpsErr = '請開啟 GPS 權限，讓我們可以提供完整的服務。';
                                break;
                            case err.TIMEOUT:
                                this.gpsErr = '取得 GPS 連線逾時，請重新整理。';
                                break;
                            default:
                                this.gpsErr = '發生未知錯誤導致無法取得 GPS。';
                        }
                    }, {
                        enableHighAccuracy: true,
                    });
                } else {
                    this.err = '裝置沒有支援 GPS 定位。';
                }
            },
            parseGPS(lat, lng) {
                this.geocoder.geocode({
                    location: {lat: lat, lng: lng}
                }, (results, status) => {
                    if (status === 'OK') {
                        let result = results[0];
                        let address = this.parseAddressComponents(result.address_components);
                        let city = address.city;
                        let district = address.district;
                        let road = address.road + address.number;
                        let additional = address.additional;

                        district = district.replace('Lake district', '內湖區');

                        if ( ! this.inWhitelist(city, district)) {
                            this.area = city;
                            this.places = [];

                            return;
                        }

                        this.address = city + district + road;
                        this.$emit('onSelected', {
                            city: city,
                            district: district,
                            road: road,
                            additional: additional,
                            latitude: result.geometry.location.lat(),
                            longitude: result.geometry.location.lng(),
                        });
                        this.onBlur();
                    }
                });
            },
        },
        mounted() {
            loaded.then(() => {
                this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
                this.autocompleteService = new window.google.maps.places.AutocompleteService();
                this.placesService = new window.google.maps.places.PlacesService(this.$refs.address);
                this.geocoder = new window.google.maps.Geocoder();
            });

            if (this.isFocus) {
                this.$refs.input.focus();
            }

            this.address = this.value;
            this.searchHistory('');
        },
        watch: {
            value() {
                this.address = this.value;
                this.searchHistory('');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .address {
        display: flex;
        align-items: center;
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 14px;
        line-height: 20px;
        border-radius: 5px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
        margin-bottom: 10px;

        img {
            width: 20px;
            height: 20px;
            margin: 10px;
        }

        input {
            width: 100%;
            border: none;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1);
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35);
            position: relative;
        }

        &.gray {
            box-shadow: none;
            background-color: #FAFAFA;

            input {
                color: #9B9B9B;
                background-color: #FAFAFA;
            }
        }

        .errMsg {
            position: absolute;
            color: rgba(244,67,54,1) !important;
            font-family: "PingFang TC";
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px !important;
            margin: 0 !important;
            background: white;
            left: 8px;
        }
    }

    .places {
        align-items: center;
        text-align: left;
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 14px;
        line-height: 20px;

        .item {
            display: flex;
            align-items: center;
            border-bottom: solid 1px rgba(51,153,51,0.1);

            img {
                width: 20px;
                height: 20px;
                margin: 10px;
                opacity: .35;

                &.noOpacity{
                    opacity: 1;
                }
            }
        }
    }

    .zero {
        margin-top: 120px;
        text-align: center;
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";

        .title {
            display: flex;
            justify-content: center;
            font-size: 20px;
            line-height: 28px;

            img {
                width: 28px;
                height: 28px;
            }
        }

        .content {
            margin-top: 5px;
            font-size: 16px;
            line-height: 22px;
        }

        .example {
            margin-top: 40px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;

            .row {
                margin-top: 20px;

                span  {
                    color: rgba(51,153,51,1);
                }
            }
        }
    }

    .area {
        margin-top: 45px;
        text-align: center;
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";

        .content {
            font-size: 20px;
            line-height: 28px;
        }

        .example {
            margin-top: 45px;
            img {
                width: 80%;
                height: auto;
            }
        }

        .buttons {
            margin-top: 20px;

            .button {
                color: #FFFFFF;
                font-family: "PingFang TC";
                font-size: 12px;
                line-height: 17px;
                text-align: center;
                border-radius: 13px;
                background-color: #339933;
                padding: 4px 14px;
                cursor: pointer;
                text-decoration: none;
            }
        }
    }

    .tip {
        text-align: left;
        color: #4A90E2;
    }
</style>
